/**
 * /app/documents — tenant-wide entry into the documents library.
 *
 * Replaced the legacy fixture redirect (hardcoded 'vandermerwe-family-trust').
 */

import { createFileRoute } from '@tanstack/react-router';
import { TrustScopedLanding } from '../../components/screens/trust-scoped-landing';

export const Route = createFileRoute('/app/documents')({
  component: () => (
    <TrustScopedLanding
      suffix="documents"
      eyebrow="Documents"
      title="Documents"
      activeNav="documents"
      emptyHelp="The documents library holds your trust deed, letters of authority, resolutions, ID copies, and other regulated artefacts. It appears here once a trust is onboarded."
    />
  ),
});
